/* ==========================================================================
   Hause of Nu: product page (sections/hon-product.liquid). Vanilla, no dependencies.
   - Gallery: a scroll-snap track (swipe on touch), thumbnails + dots jump to a slide,
     arrow keys on the focused track, active state follows the scroll position.
   - Variant select (products with several variants); shade swatches drive it, ?variant= follows.
   - Pre-order label falls back to "Add to bag" once the launch time has passed.
   - Sticky add-to-bag bar (small screens) once the main button has scrolled away.
   Add to bag itself is Dawn's <product-form> (assets/product-form.js).
   Quantity stepper and countdown are in hon.js.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $ = function (sel, ctx) { return (ctx || doc).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); };

  function once(el, key) {
    var attr = 'data-hon-pdp-' + key + '-bound';
    if (el.hasAttribute(attr)) return false;
    el.setAttribute(attr, '');
    return true;
  }

  /* Gallery ------------------------------------------------------------- */
  function initGallery(gallery) {
    if (!once(gallery, 'gallery')) return;
    var track = $('[data-hon-pdp-track]', gallery);
    var slides = $$('[data-hon-pdp-slide]', gallery);
    var controls = $$('[data-hon-pdp-go]', gallery);
    if (!track || slides.length < 2) return;
    var current = 0;

    function setActive(index) {
      current = index;
      controls.forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(Number(btn.getAttribute('data-hon-pdp-go')) === index));
      });
    }
    function goTo(index, instant) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      var img = $('img[loading="lazy"]', slides[index]);
      if (img) img.loading = 'eager';
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
      setActive(index);
    }
    controls.forEach(function (btn) {
      btn.addEventListener('click', function () { goTo(Number(btn.getAttribute('data-hon-pdp-go'))); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== current && i >= 0 && i < slides.length) setActive(i);
      });
    }, { passive: true });
    /* keep the active slide in place when the layout width changes */
    window.addEventListener('resize', function () {
      track.scrollLeft = slides[current].offsetLeft - track.offsetLeft;
    }, { passive: true });
    gallery._honGoTo = goTo;
    gallery._honSlides = slides;
  }

  /* Variant select (shade swatches drive the hidden select) -------------- */
  function initVariant(section) {
    var select = $('[data-hon-pdp-variant]', section);
    if (!select || !once(select, 'variant')) return;
    var showMedia = function (opt, instant) {
      var media = opt.getAttribute('data-media');
      var gallery = $('[data-hon-pdp-gallery]', section);
      if (!media || !gallery || !gallery._honGoTo) return;
      gallery._honSlides.forEach(function (slide, i) {
        if (slide.getAttribute('data-media-id') === media) gallery._honGoTo(i, instant);
      });
    };
    var apply = function () {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var available = opt.getAttribute('data-available') === 'true';
      var idInput = $('form input[name="id"]', section);
      if (idInput) {
        idInput.value = opt.value;
        idInput.disabled = !available;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var price = opt.getAttribute('data-price');
      $$('[data-hon-pdp-price], [data-hon-pdp-bar-price]', section).forEach(function (el) { el.textContent = price; });
      var compare = $('[data-hon-pdp-compare]', section);
      if (compare) {
        var cmp = opt.getAttribute('data-compare');
        var hidden = $('.hon-visually-hidden', compare);
        compare.textContent = '';
        if (hidden) compare.appendChild(hidden);
        if (cmp) compare.appendChild(doc.createTextNode(cmp));
        compare.hidden = !cmp;
      }
      var submit = $('[data-hon-pdp-add]', section);
      if (submit) {
        submit.disabled = !available;
        var label = available ? currentAddLabel(submit) : submit.getAttribute('data-label-soldout');
        setLabels(section, label);
      }
      var bar = $('[data-hon-pdp-bar-btn]', section);
      if (bar) bar.disabled = !available;
      $$('[data-hon-pdp-shade]', section).forEach(function (input) {
        if (input.value === opt.value) {
          input.checked = true;
          var name = $('[data-hon-pdp-shade-name]', section);
          if (name) name.textContent = input.getAttribute('data-name');
        }
      });
      if (select.hasAttribute('data-hon-pdp-history') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', opt.value);
        window.history.replaceState(window.history.state, '', url.toString());
      }
      showMedia(opt);
    };
    select.addEventListener('change', apply);
    $$('[data-hon-pdp-shade]', section).forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked || select.value === input.value) return;
        select.value = input.value;
        apply();
      });
    });
    /* opened on a specific variant (?variant=): start the gallery on its photo */
    var first = select.options[select.selectedIndex];
    if (first && first.getAttribute('data-media')) showMedia(first, true);
  }

  /* Labels: pre-order until the launch time, then add to bag ------------ */
  function currentAddLabel(submit) {
    var until = submit.getAttribute('data-hon-pre-until');
    if (until) {
      var t = new Date(until).getTime();
      if (!isNaN(t) && Date.now() < t) return submit.getAttribute('data-label-pre');
    }
    return submit.getAttribute('data-label-add');
  }
  function setLabels(section, text) {
    $$('[data-hon-pdp-add-label]', section).forEach(function (el) {
      if (el.textContent !== text) el.textContent = text;
    });
  }
  function initPreorder(section) {
    var submit = $('[data-hon-pdp-add]', section);
    if (!submit || !submit.hasAttribute('data-hon-pre-until') || submit.disabled) return;
    var check = function () {
      var label = currentAddLabel(submit);
      setLabels(section, label);
      return label === submit.getAttribute('data-label-add');
    };
    if (check()) return;
    var timer = window.setInterval(function () { if (check()) window.clearInterval(timer); }, 30000);
  }

  /* Sticky bar ---------------------------------------------------------- */
  function initBar(section) {
    var bar = $('[data-hon-pdp-bar]', section);
    var submit = $('[data-hon-pdp-add]', section);
    if (!bar || !submit || !once(bar, 'bar')) return;
    var show = function (on) {
      bar.classList.toggle('is-visible', on);
      if (on) { bar.removeAttribute('aria-hidden'); bar.removeAttribute('inert'); }
      else { bar.setAttribute('aria-hidden', 'true'); bar.setAttribute('inert', ''); }
      doc.documentElement.classList.toggle('hon-pdp-bar-on', on);
    };
    /* visible only once the main button has left through the top of the viewport */
    var on = false;
    var ticking = false;
    var check = function () {
      ticking = false;
      var next = submit.getBoundingClientRect().bottom < 0;
      if (next !== on) { on = next; show(on); }
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
    }, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  }

  function init(ctx) {
    $$('[data-hon-pdp]', ctx).concat(ctx && ctx.matches && ctx.matches('[data-hon-pdp]') ? [ctx] : []).forEach(function (section) {
      $$('[data-hon-pdp-gallery]', section).forEach(initGallery);
      initVariant(section);
      initPreorder(section);
      initBar(section);
    });
  }

  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);
})();
